<template>
  <datepicker
    v-model="_value"
    :language="ja"
    placeholder="Select Date"
    format="yyyy年M月"
    class="base-datepicker"
    input-class="base-datepicker__input"
    calendar-class="base-datepicker__calendar"
    wrapper-class="base-datepicker__wrapper" />
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
export default {
  components: {
    Datepicker
  },
  props: {
    value: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      ja
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss">
.base-datepicker {

  &__input {
    background-color: transparent;
    border: none;
    text-align: center;
    width: 100px;

    font-weight: 700;
  }

  &__calendar {
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);

    .cell {
      border-radius: 50%;

      &.today {
        background-color: lighten($l-blue, 50%)
      }

      &.selected {
        background-color: $l-blue;
        color: $white;
      }
    }
  }

  &__wrapper {

  }
}

</style>